import { render } from "./BodySystem.vue?vue&type=template&id=b06a40c4&scoped=true"
import script from "./BodySystem.vue?vue&type=script&lang=js"
export * from "./BodySystem.vue?vue&type=script&lang=js"

import "./BodySystem.vue?vue&type=style&index=0&id=b06a40c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06a40c4"]])

export default __exports__